import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getOrganizations } from '../../api/ebs-api/index.js';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to access EBS organizations.
 */
export const useOrganizations = () => {
  const { apiReady } = useApiReady();

  return useQuery({
    queryKey: [QUERY_KEYS.ORGANIZATION_DATA],
    queryFn: () => getOrganizations(),
    staleTime: Infinity,
    enabled: apiReady,
  });
};
